module.exports = __webpack_public_path__ + "static/media/loader-title.6be08116.svg";